export default __webpack_public_path__ + "static/media/c002-PPII-7.80042ba6.svg";